import { addEasing } from "@tsparticles/engine";
export async function loadEasingCircPlugin() {
    addEasing("ease-in-circ", (value) => 1 - Math.sqrt(1 - value ** 2));
    addEasing("ease-out-circ", (value) => Math.sqrt(1 - (value - 1) ** 2));
    addEasing("ease-in-out-circ", (value) => value < 0.5 ? (1 - Math.sqrt(1 - (2 * value) ** 2)) / 2 : (Math.sqrt(1 - (-2 * value + 2) ** 2) + 1) / 2);
}
